module.exports = __webpack_public_path__ + "img/no-comparaison.d015ce14.svg";